import Vue from 'vue'
import App from './App.vue'
import router from './router'
import Cookies from 'js-cookie'
import VueLazyload from 'vue-lazyload'

import store from './store'
import formatUtil from './fix.js'

Vue.config.productionTip = false

//引入eleui
import ElementUI from 'element-ui';
import './style/element-variables.scss'

import './plugins/element.js'
//import './icons' // icon
import './permission' // permission control
import './utils/error-log' // error log
import './assets/iconfont/iconfont.css'
import './style/css.css'

//import './utils/chatToolUser.js'
// 分享插件
import vshare from 'vshare'
ElementUI.Dialog.props.closeOnClickModal.default = false

Vue.use(ElementUI);
Vue.use(VueLazyload);
Vue.use(vshare);
Vue.use(formatUtil);

// 截掉时分秒
Vue.filter('splitTime', function(val) {
  if (!val) {
    return ''
  }
  return val.split(' ')[0]
})


new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})
